/**
 * Created by liubaorui on 22/11/11.
 * @desc 拼音码使用通用Api函数
 *  TODO: 目前此文件仅支持拼音码使用， 需要抽离成公共方法,可尝试抽离至 common.js 并删除本文件
 */

import request from '@/router/axios';

// GET请求
export const getDictionaries = async (url, query, timeout = 10000) => {
  const { data: { data } }
    = await request({
      url,
      method: 'get',
      params: {
        ...query
      },
      timeout,
    })
  return data
}

export const getDictionariesAutocomplete = async (url, query, timeout = 10000) => {
    const {data}
        = await request({
            url,
            method: 'get',
            params: {
                ...query
            },
            timeout,
        })

    console.log(data,'Arraydata');
        
    return data
}
// 取消 Http 重复请求
export const getDictionariesCancel = async (url, query = {}) => {
  let url_list = url.split('?')
  let params_all = url_list[1] ? url_list[1].split('&').map(item => item.split('=')) : '' || []
  let params_lits = []
  let params = {}
  if (params_all) {
    params_all.forEach(item => Array.isArray(item) ? params_lits.push(...item) : params_lits.push(item));
    params_lits.map((item, index) => {
      (index % 2) === 0 || index === 0 ? params[params_lits[index]] = params_lits[index + 1] : false
    })
  }
    const {data}
    = await request({
      url: url_list[0],
      method: 'get',
      params: {
        ...params,
        ...query
      },
      cancel: true
    })

    console.log(data,'data--==');
    
    return data
}
